import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  Divider,
  TextField
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import clientBackend from "configurations/axios";
import Alert from "widgets/alert";
import useForm from "hooks/useFrom";
import validations from "../validations";
import {
  API_POST_SAVE_PRODUCTS,
  API_GET_ALL_MEASURES,
  API_GET_SEARCH_FAMILY_MEASURES,
  API_GET_SEARCH_UNIT_MEASURES,
  API_GET_ALL_CODING_SEGMENT_PA,
  API_GET_SEARCH_CODING_FAMILY_PA
} from "../apis";
import { useStylesApp } from "hooks/useStyles";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const AddProductsBtn = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const userToken = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const { enqueueSnackbar } = useSnackbar();
  const [regexInventarioError, setRegexInventarioError] = useState(false);
  const [regexError, setRegexError] = useState(false);
  
  const [products, setProducts] = useState({
    idEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
    precioUnitario: null
  });
  //MEDIDAS
  const [measure, setMeasure] = useState([]);
  const [loadMeasure, setLoadMeasure] = useState(true);
  const [selectedMeasure, setSelectedMeasure] = useState({
    idMedida: "",
  });
  //FAMILIA MEDIDAS
  const [familyMeasure, setFamilyMeasure] = useState([]);
  const [loadFamilyMeasure, setLoadFamilyMeasure] = useState(true);
  const [selectedFamilyMeasure, setSelectedFamilyMeasure] = useState({
    idFamiliaMedida: "",
  });
  //UNIDADES DE MEDIDA
  const [unitMeasure, setUnitMeasure] = useState([]);
  const [loadUnitMeasure, setLoadUnitMeasure] = useState(true);
  const [selectedUnitMeasure, setSelectedUnitMeasure] = useState({
    idUnidadMedida: "",
  });
  //SEGMENTOS CODIFICACION PANAMEÑA DE BIENES Y SERVICIOS
  const [codingSegmentPa, setCodingSegmentPa] = useState([]);
  const [loadCodingSegmentPa, setLoadCodingSegmentPa] = useState(true);
  const [selectedCodingSegmentPa, setSelectedCodingSegmentPa] = useState({
    idCodificacionBienesServicios: "",
  });
  //FAMILIA CODIFICACION PANAMEÑA DE BIENES Y SERVICIOS
  const [codingFamilyPa, setCodingFamilyPa] = useState([]);
  const [loadCodingFamilyPa, setLoadCodingFamilyPa] = useState(true);
  const [selectedCodingFamilyPa, setSelectedCodingFamilyPa] = useState({
    idCodificacionBienesServicios: "",
  });

  useEffect(() => {
    if (!selectedCodingSegmentPa) {
      setSelectedCodingFamilyPa({});
    }

  }, [selectedCodingSegmentPa])

  const handleClose = () => {
    setOpen(false);
    setProducts({
      idEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
    });
    getObject({
      idEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
    });
    setMeasure([]);
    setFamilyMeasure([]);
    setUnitMeasure([]);
    setCodingSegmentPa([]);
    setCodingFamilyPa([]);
  };

  const existError = () => {
    setOpenLoader(false);
  };

  const handleSave = async () => {
    setOpenLoader(true);
    await clientBackend
      .post(API_POST_SAVE_PRODUCTS, products)
      .then((response) => {
        if (response.status === 200) {
          enqueueSnackbar("Producto/Servicio Agregado", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 10000,
          });
          updateView();
          setOpenLoader(false);
          handleClose();
        }
      })
      .catch((exception) => {
        if (exception.response) {
          if (exception.response.status === 400) {
            setMsg({ show: true, msg: "No se pudo almacenar el producto." });
          } else if (exception.response.status === 404) {
            setMsg({
              show: true,
              msg:
                "No se encontró la empresa enviada para relacionarla con el producto.",
            });
          } else if (exception.response.status === 409) {
            setMsg({
              show: true,
              msg: "El Código principal ya está asignado a otro producto.",
            });
          } else {
            setMsg({
              show: true,
              msg:
                "Error al actualizar el producto. Contáctese con el administrador del Sistema.",
            });
          }
        } else {
          setMsg({
            show: true,
            msg:
              "Existen problemas en la red. Contáctese con el administrador del Sistema.",
          });
        }
        setOpenLoader(false);
      });
  };

  const { errors, handleSubmit, getObject } = useForm(
    handleSave,
    validations.addProduct,
    existError
  );

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClickOpen = () => {
    setOpen(true);
    setLoadMeasure(true);
    setLoadCodingSegmentPa(true);
    setProducts({ idEmpresa: userToken ? getRUCEmpresa(userToken) : "0" });
    errors.codigoPrincipal = null;
    errors.codigoAuxiliar = null;
    errors.descripcion = null;
    errors.precioUnitario = null;
    setMsg({ show: false, msg: null, type: null });
    setSelectedMeasure({ idMedida: "" });
    setSelectedFamilyMeasure({ idFamiliaMedida: "" });
    setSelectedUnitMeasure({ idUnidadMedida: "" });
    setSelectedCodingSegmentPa({ idCodificacionBienesServicios: "" });
    setSelectedCodingFamilyPa({ idCodificacionBienesServicios: "" });
  };

  const handleInvalidPrecie = (event) => {
    event.preventDefault();
    getObject(products);
    handleSubmit(event)
  }

  const handleChange = (event) => {
    let { isValid, value } = validations.changeProduct(
      event.target.name,
      event.target.value
    );
    if (isValid) {
      setProducts({
        ...products,
        [event.target.name]: value,
      });
      getObject({
        ...products,
        [event.target.name]: value,
      });
    }
  };

  const getMeasures = async (token) => {
    setLoadMeasure(false);
    if (open) {
      await clientBackend
        .get(API_GET_ALL_MEASURES)
        .then((result) => {
          if (result.status === 200) {
            let measures = result.data;
            for (let i = 0; i < measures.length; i++) {
              measures[i].label =
                measures[i].medida;
            }
            setMeasure(measures);
          }
        })
        .catch((exception) => {
          setMeasure([{ label: "Error al cargar las medidas" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las medidas.",
          });
        });
    }
  };

  const getFamilyMeasures = async (measureSelect) => {
    setLoadFamilyMeasure(false);
    if (open) {
      await clientBackend
        .get(API_GET_SEARCH_FAMILY_MEASURES + '/' + measureSelect)
        .then((result) => {
          if (result.status === 200) {
            let familyMeasures = result.data;
            for (let i = 0; i < familyMeasures.length; i++) {
              familyMeasures[i].label =
                familyMeasures[i].nombre;
            }
            setFamilyMeasure(familyMeasures);
          }
        })
        .catch((exception) => {
          setFamilyMeasure([{ label: "Error al cargar las familias de medidas" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las familias de medidas.",
          });
        });
    }
  };

  const getUnitMeasures = async (familyMeasureSelect) => {
    setLoadUnitMeasure(false);
    if (open) {
      await clientBackend
        .get(API_GET_SEARCH_UNIT_MEASURES + '/' + familyMeasureSelect)
        .then((result) => {
          if (result.status === 200) {
            let unitMeasures = result.data;
            for (let i = 0; i < unitMeasures.length; i++) {
              unitMeasures[i].label =
                unitMeasures[i].comentario +
                " ( " +
                unitMeasures[i].simbolo + ")";
            }
            setUnitMeasure(unitMeasures);
          }
        })
        .catch((exception) => {
          setUnitMeasure([{ label: "Error al cargar las unidades de medidas" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las unidades de medida.",
          });
        });
    }
  };

  const getCodingSegmentPa = async (token) => {
    setLoadCodingSegmentPa(false);
    if (open) {
      await clientBackend
        .get(API_GET_ALL_CODING_SEGMENT_PA)
        .then((result) => {
          if (result.status === 200) {
            let codingSegmentsPa = result.data;
            for (let i = 0; i < codingSegmentsPa.length; i++) {
              codingSegmentsPa[i].label =
                codingSegmentsPa[i].codigo +
                " / " +
                codingSegmentsPa[i].nombre;
            }
            setCodingSegmentPa(codingSegmentsPa);
          }
        })
        .catch((exception) => {
          setCodingSegmentPa([{ label: "Error al cargar los segmentos de la codificación Panameña de Bienes y Servicios" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar los segmentos de la codificación Panameña de Bienes y Servicios.",
          });
        });
    }
  };

  const getCodingFamilyPa = async (codingSegmentPaSelect) => {
    setLoadCodingFamilyPa(false);
    if (open) {
      await clientBackend
        .get(API_GET_SEARCH_CODING_FAMILY_PA + '/' + codingSegmentPaSelect)
        .then((result) => {
          if (result.status === 200) {
            let codingFamiliesPa = result.data;
            for (let i = 0; i < codingFamiliesPa.length; i++) {
              codingFamiliesPa[i].label =
                codingFamiliesPa[i].codigo +
                " / " +
                codingFamiliesPa[i].nombre;
            }
            setCodingFamilyPa(codingFamiliesPa);
          }
        })
        .catch((exception) => {
          setCodingFamilyPa([{ label: "Error al cargar las familias de la codificación de bienes y servicios Panameña" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las familias de la codificación de bienes y servicios Panameña.",
          });
        });
    }
  };

  const renderMeasures = () => {
    if (measure.length === 0 && userToken && loadMeasure) {
      getMeasures(userToken);
    }
    return (
      <Autocomplete
        value={selectedMeasure}
        onChange={(event, newValue) => {
          setSelectedMeasure(newValue);
          setLoadFamilyMeasure(true);
          if (newValue) {
            getFamilyMeasures(newValue.idMedida);
          }
        }}
        options={measure}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={measure.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de medidas"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {measure.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const renderFamilyMeasures = () => {
    // if (familyMeasure.length === 0 && userToken && loadFamilyMeasure) {
    //   getFamilyMeasures(userToken);
    // }
    return (
      <Autocomplete
        value={selectedFamilyMeasure}
        onChange={(event, newValue) => {
          setSelectedFamilyMeasure(newValue);
          setLoadUnitMeasure(true);
          if (newValue) {
            getUnitMeasures(newValue.idFamiliaMedida);
          }
        }}
        options={familyMeasure}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={familyMeasure.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de familia de medidas"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {familyMeasure.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const renderUnitMeasures = () => {
    // if (unitMeasure.length === 0 && userToken && loadUnitMeasure) {
    //   getUnitMeasures(userToken);
    // }
    return (
      <Autocomplete
        value={selectedUnitMeasure}
        onChange={(event, newValue) => {
          setSelectedUnitMeasure(newValue);
          setProducts({
            ...products,
            codigoUnidadMedida: newValue ? newValue.idUnidadMedida : ""
          });
        }}
        options={unitMeasure}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={unitMeasure.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de unidades de medida"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {unitMeasure.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const renderCodingSegmentPa = () => {
    if (codingSegmentPa.length === 0 && userToken && loadCodingSegmentPa) {
      getCodingSegmentPa(userToken);
    }
    return (
      <Autocomplete
        value={selectedCodingSegmentPa}
        onChange={(event, newValue) => {
          setSelectedCodingSegmentPa(newValue);
          setLoadCodingFamilyPa(true);
          if (newValue) {
            getCodingFamilyPa(newValue.idCodificacionBienesServicios);
          }
          setProducts({
            ...products,
            codigoBienesServicios: newValue ? newValue.idCodificacionBienesServicios : ""
          });
        }}
        options={codingSegmentPa}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={codingSegmentPa.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de segmentos de codificación Panameña"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {codingSegmentPa.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const renderCodingFamilyPa = () => {
    // if (codingFamilyPa.length === 0 && userToken && loadCodingFamilyPa) {
    //   getCodingFamilyPa(userToken);
    // }
    return (
      <Autocomplete
        value={selectedCodingFamilyPa}
        onChange={(event, newValue) => {
          setSelectedCodingFamilyPa(newValue);
          setProducts({
            ...products,
            codigoBienesServicios: newValue ? newValue.idCodificacionBienesServicios : ""
          });
        }}
        options={codingFamilyPa}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={codingFamilyPa.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de familias de la codificación Panameña"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {codingFamilyPa.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };
  const [limitMessage, setLimitMessage] = useState(false);
  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <AddCircleIcon
          style={{ color: palette.primary.contrastText, paddingRight: "3%" }}
          fontSize="small"
        />{" "}
        Agregar Producto{" "}
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Nuevo Producto / Servicio
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              <Grid item xs={12} md={12}>
                <label>
                  Considere que si usted va facturar para un cliente de gobierno su producto debe de tener los campos segmento y familia de codificación Panameña de bienes y servicios abreviados, es obligatorio ({" "}
                  <font color={palette.error.main}> *</font> )
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Código principal: <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
              <input
                  type="text"
                  className={
                    errors.codigoPrincipal
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. 001 (Máximo 20 caracteres)"
                  name="codigoPrincipal"
                  value={products.codigoPrincipal || ""}
                  autoComplete="off"
                  maxLength={20}
                  onChange={(e) => {
                    let { value } = e.target;

                    if (value.length > 20) {
                      setLimitMessage(true);
                      value = value.slice(0, 20);
                    } else {
                      setLimitMessage(false);
                    }

                    handleChange({
                      target: {
                        name: "codigoPrincipal",
                        value: value,
                      },
                    });
                  }}
                />

                {limitMessage && (
                  <small style={{ color: "red" }}>
                    Máximo número 20 caracteres
                  </small>
                )}
                {errors.codigoPrincipal ? (
                  <p className={classesApp.errorLetters}>
                    {errors.codigoPrincipal}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>Código auxiliar:</label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <input
                  type="text"
                  className={
                    errors.codigoAuxiliar
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. 0001"
                  name="codigoAuxiliar"
                  value={products.codigoAuxiliar}
                  onChange={handleChange}
                  autoComplete="off"
                />
                {errors.codigoAuxiliar ? (
                  <p className={classesApp.errorLetters}>
                    {errors.codigoAuxiliar}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Descripción: <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <input
                  type="text"
                  className={
                    errors.descripcion
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. zapato"
                  name="descripcion"
                  value={products.descripcion}
                  onChange={handleChange}
                  autoComplete="off"
                />
                {errors.descripcion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.descripcion}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Precio Unitario: <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <input
                  type="number"
                  className={
                    errors.precioUnitario
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. 10.01"
                  name="precioUnitario"
                  value={products.precioUnitario}
                  onChange={handleChange}
                  autoComplete="off"
                  onInvalid={handleInvalidPrecie}
                />
                {errors.precioUnitario ? (
                  <p className={classesApp.errorLetters}>
                    {errors.precioUnitario}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  GTIN comercialización:
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
              <input
                type="text"
                className={
                  errors.gtincomercializacion || regexError
                    ? "form-control is-invalid"
                    : "form-control"
                }
                placeholder="Ej. 0, 12345678, 123456789012"
                name="gtincomercializacion"
                value={products.gtincomercializacion || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^([0]{1}|[0-9]{8}|[0-9]{12,14})$/;

                  if (value === "" || regex.test(value)) {
                    setRegexError(false);
                    handleChange(e);
                  } else {
                    setRegexError(true); // activa el error
                    handleChange({ target: { name: "gtincomercializacion", value } });
                  }
                }}
                autoComplete="off"
              />
              {(errors.gtincomercializacion || regexError) && (
                <p className={classesApp.errorLetters}>
                  {regexError
                    ? "El valor debe ser 0, un número de 8 dígitos o un número de 12 a 14 dígitos"
                    : errors.gtincomercializacion}
                </p>
              )}
            </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  GTIN inventario:
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
              <input
                type="text" // cambiamos a text para permitir ceros iniciales
                className={
                  errors.gtinInventario || regexInventarioError
                    ? "form-control is-invalid"
                    : "form-control"
                }
                placeholder="Ej. 0, 12345678, 123456789012"
                name="gtinInventario"
                value={products.gtinInventario || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^([0]{1}|[0-9]{8}|[0-9]{12,14})$/;

                  if (value === "" || regex.test(value)) {
                    setRegexInventarioError(false);
                    handleChange(e);
                  } else {
                    setRegexInventarioError(true); // activa el error
                    handleChange({ target: { name: "gtinInventario", value } });
                  }
                }}
                autoComplete="off"
              />
              {(errors.gtinInventario || regexInventarioError) && (
                <p className={classesApp.errorLetters}>
                  {regexInventarioError
                    ? "El valor debe ser 0, un número de 8 dígitos o un número de 12 a 14 dígitos"
                    : errors.gtinInventario}
                </p>
              )}
            </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Medida:
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderMeasures()}
              </Grid>
              {selectedMeasure ?
                selectedMeasure.idMedida ?
                  <>
                    <Grid item xs={12} md={2} className={classes.divForm}>
                      <label>
                        Familia de Medidas:
                      </label>
                    </Grid>
                    <Grid item xs={12} md={4} className={classes.divInput}>
                      {renderFamilyMeasures()}
                    </Grid>
                  </>
                  : null
                : null}

              {selectedFamilyMeasure && selectedMeasure ?
                selectedFamilyMeasure.idFamiliaMedida ?
                  <>
                    <Grid item xs={12} md={2} className={classes.divForm}>
                      <label>
                        Unidades de Medidas:
                      </label>
                    </Grid>
                    <Grid item xs={12} md={4} className={classes.divInput}>
                      {renderUnitMeasures()}
                    </Grid>
                  </>
                  : null
                : null}
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Segmento de Codificación Panameña de Bienes y Servicios:
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderCodingSegmentPa()}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <label>
                  Familia de Codificación Panameña de Bienes y Servicios:
                </label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderCodingFamilyPa()}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AddProductsBtn;
